module.exports = __webpack_public_path__ + "img/sushitataroverviewwide.535040ea.jpg";